<template>
    <div id="StockInventoryOnline">
      <div class="mr-4">
        <div class="d-flex justify-content-between" style="align-items: center">
          <div class="d-flex ml-4">
            <div class="stock-box px-3 py-2">
              <p class="text-caption mb-0">Stock</p>
              <h4 class="text-h6 text-weight-bolder">{{ getProductCount }}</h4>
            </div>
          </div>
          <!-- <div class="d-flex">
            <div @click="$router.push('/Partners/Stock/Products')" class="addButton-2 d-flex mt-1" style="height: 40px;">
              <div class=" mx-auto my-auto">Add Order</div>
            </div>
            <q-input v-model="filter" class="searchBox" debounce="500" placeholder="Search" style="width: 350px">
              <template v-slot:prepend>
                <q-icon name="search"/>
              </template>
            </q-input>
          </div> -->
        </div>
      </div>
  
      <div class="d-flex q-pa-md pt-0 row" style="margin-top: 50px">
        <div class="col-6 col-sm-4 col-md-3 col-lg-2 q-pa-sm" v-for="(product, index) in productArr"
             v-if="product.batches_aggregate.aggregate.count>0">
          <div class="rd-dashboard cursor-pointer"
               @click="openProductBatchesDialog(product.id, product.batches_aggregate.aggregate.count)"
               style="height: 100%">
            <div class="container p-4">
              <h5 class="text-h4" style="color: #2d2d2d;">{{ product.batches_aggregate.aggregate.count }}</h5>
              <h4 class="mt-3" style="color: #2d2d2d; line-height: 1.5rem;">{{ product.name }}</h4>
            </div>
          </div>
        </div>
      </div>
  
      <div v-if="!productArr.length">
        <img alt="" class="d-block mx-auto " src="../../assets/no_Data.png" style="width: 25%;">
        <h6 class="text-center">No data available</h6>
      </div>
  
      <q-dialog v-model="productBatchesDialog" persistent position="right">
        <product-batches-drawer-online :filter="searchData" :productId="productId"
                                :totalBatchcount="totalBatchcount"
                                @closeProductBatchesDialog="productBatchesDialog=false"></product-batches-drawer-online>
      </q-dialog>
      <q-dialog v-model="inventoryHistoryDialog" persistent position="right">
        <inventory-history @closeInventoryHistoryDialog="inventoryHistoryDialog=false"/>
      </q-dialog>
  
      <ManageActiveSubBatches :subBatchDialog.sync="subBatchDialog"/>
    </div>
  </template>
  
  <script>
  import { GET_MY_BATCHES_GROUP_BY_PRODUCT_ONLINE } from '../../graphql/queries/batch'
  import ProductBatchesDrawerOnline from './ProductBatchesDrawerOnline'
  import InventoryHistory from './InventoryHistory'
  import Constants from '@/Constants/Constant'
  import ManageActiveSubBatches from "@/components/ManageSubBatches/ManageActiveSubBatches";
  
  export default {
    apollo: {
        OnlineProducts: {
        query: GET_MY_BATCHES_GROUP_BY_PRODUCT_ONLINE,
        fetchPolicy: 'network-only',
        variables () {
          return { orgId: this.userObj.orgId, filter: this.combineFilter }
        },
        result ({ data, loading }) {
          if (!loading) {
            this.productArr = data.OnlineProducts
            let partnerType = this.userObj.organization.partnerType
          }
        },
      },
    },
    name: 'StockOnline',
    props: {
      searchData: {
        // type: String,
        default: ''
      },
    },
    components: {ManageActiveSubBatches, InventoryHistory, ProductBatchesDrawerOnline },
    data: function () {
      return {
        Constants,
        userObj: JSON.parse(localStorage.getItem('user')),
        productArr: [],
        // filter: '',
        productBatchesDialog: false,
        productId: '',
        totalBatchcount: 0,
        inventoryHistoryDialog: false,
        currentRolePrice: '',
        subBatches: [],
        subBatchDialog: false
      }
    },
  
    computed: {
      combineFilter () {
        // return '%' + this.filter.trim() + '%'
        return '%' + this.searchData.trim() + '%'
      },
      getProductCount () {
        let total = 0
        this.productArr.forEach(product => {
          total += product.batches_aggregate.aggregate.count
        })
        return total
      },
    },
    methods: {
      openProductBatchesDialog (productId, totalBatchcount) {
        this.productId = productId
        this.totalBatchcount = totalBatchcount
        this.productBatchesDialog = true
      },
    },
  }
  </script>
  
  <style lang="stylus" scoped>
  .rd-theme {
    background: #3a9cac;
  }
  
  * {
    /*font-family: avenirRegular;*/
  }
  
  #StockInventory
    background #fff
    /*height 89vh*/
  
    .vad-dashboard, .vap-dashboard, .rd-dashboard {
      /*width: 49%;*/
      /*border-radius 5px*/
      /*border: 1px solid #008793;*/
      border-radius 5px
      transition 0.3s
      background #efefef
      color #4c4c4c
      /*  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2) */
  
      h4 {
        color #383838 !important
      }
  
      .heading {
        color: #383838 !important
      }
    }
  
    .vap-dashboard {
      background #ff9319
    }
  
    .rd-dashboard {
      background #efefef
      color #4c4c4c
    }
  
    .vad-dashboard:hover, .vap-dashboard:hover, .rd-dashboard:hover {
      background: rgba(0, 135, 147, 0.07)
      cursor: pointer
  
      h4 {
        color #2d2d2d !important
      }
  
      .heading {
        color: #2d2d2d !important
      }
    }
  
  .container
    font-weight bolder !important
    color #2D2D2D
    text-transform uppercase
    /* padding: 2px 16px; */
    padding-left 22px
    transition 0.3s
  
  .container:hover {
    background: #f9f9f9c4
  }
  
  .container h4
    font-size 16px
    transition all 0.3s
    line-height 80px;
    color: #fff
  
  .container .heading
    font-family: avenirRegular;
    transition all 0.3s
    line-height 50px
    margin-top: 15px
    color #383838
  
  /*.card:hover .container .heading*/
  /*color #2D2D2D*/
  
  /*.card:hover .container h4*/
  /*color #2D2D2D*/
  
  </style>
  <style lang="scss">
  .stock-box {
    background: #E7EFF4;
    border-radius: 10px;
    min-width: 150px;
    color: #115A92;
  }

  .rd-dashboard {
      background: #efefef;
      color: #4c4c4c;
      border-radius: 5px;
      transition: 0.3s;
    }
  
  .price-box {
    background: #E5F9E7;
    border-radius: 10px;
    min-width: 150px;
    color: #00C714;
  }
  </style>
  